export default [
    {
        component: () => import(/* webpackChunkName: 'regulacao-reagendamento-medico' */ '@/views/regulacao/reagendamento-medico/Index'),
        path: 'reagendamento-medico',
        redirect: 'reagendamento-medico/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'regulacao-reagendamento-medico' */ '@/views/regulacao/reagendamento-medico/List'),
                name: 'regulacao-reagendamento-medico-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'regulacao-reagendamento-medico' */ '@/views/regulacao/reagendamento-medico/Form'),
                name: 'regulacao-reagendamento-medico-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
            },
        ],
    },
]
